exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error-container {\n    margin: 4px 0;\n}\n", ""]);

// exports
